import * as React from 'react';
import { IconProps } from '../types';

const IcColorFill = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M7.42 1.3c.094-.126.284-.26.434-.118 2.889 2.865 5.762 5.753 8.642 8.626.11.119.261.222.285.396.047.19-.048.38-.19.498-2.208 2.2-4.408 4.408-6.616 6.608a.473.473 0 0 1-.688.008L2.639 10.67a.5.5 0 0 1-.015-.728c1.804-1.804 3.608-3.616 5.42-5.412-.554-.538-1.1-1.1-1.654-1.646a1.076 1.076 0 0 1-.213-.285c.356-.475.83-.863 1.242-1.298Zm2.073 4.425c-1.504 1.519-3.023 3.03-4.535 4.542 3.11 0 6.22.008 9.33-.008-1.55-1.551-3.102-3.094-4.645-4.653-.048.04-.103.079-.15.119ZM17.723 14.596c.411-.68.894-1.314 1.424-1.9.704.824 1.377 1.694 1.82 2.691.214.475.332 1.021.174 1.527-.221.879-1.06 1.575-1.978 1.56-.981.04-1.907-.736-2.058-1.702-.158-.775.246-1.52.618-2.176ZM2.046 20.578c-.008-.15.142-.245.277-.221h20.346c.102-.016.197.047.284.102.008.744.008 1.488 0 2.232.008.15-.166.19-.277.182H2.331a.23.23 0 0 1-.277-.253 58.71 58.71 0 0 1-.008-2.042Z"
    />
  </svg>
);

export default IcColorFill;